var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCandidate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 18,
    fill: "#F2F2F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1152,
    height: 700,
    transform: "translate(-26 -143)",
    fill: "#F9FBFD"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -26,
    y: -143,
    width: 220,
    height: 700,
    fill: "#0A0C0B"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -16,
    y: -13,
    width: 200,
    height: 43,
    rx: 2,
    fill: "var(--svgaccordionbackgroundcolor)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_5_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.16406 8.71143C10.4092 8.71143 12.2276 6.72608 12.2276 4.29541C12.2276 1.90186 10.4092 0 8.16406 0C5.92822 0 4.09131 1.92969 4.10058 4.31397C4.10986 6.73536 5.91894 8.71143 8.16406 8.71143ZM8.16406 7.08789C6.88379 7.08789 5.79834 5.87256 5.79834 4.31397C5.78906 2.79248 6.87451 1.62354 8.16406 1.62354C9.46286 1.62354 10.5298 2.77393 10.5298 4.29541C10.5298 5.85401 9.45366 7.08789 8.16406 7.08789ZM2.375 17.3394H13.9439C15.5489 17.3394 16.3189 16.8291 16.3189 15.7344C16.3189 13.1831 13.1368 9.78757 8.16406 9.78757C3.1914 9.78757 0 13.1831 0 15.7344C0 16.8291 0.770022 17.3394 2.375 17.3394ZM2.0874 15.7159C1.86474 15.7159 1.78125 15.6416 1.78125 15.4746C1.78125 14.0552 4.07275 11.4112 8.16406 11.4112C12.2461 11.4112 14.5376 14.0552 14.5376 15.4746C14.5376 15.6416 14.4541 15.7159 14.2315 15.7159H2.0874Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.16406 8.71143C10.4092 8.71143 12.2276 6.72608 12.2276 4.29541C12.2276 1.90186 10.4092 0 8.16406 0C5.92822 0 4.09131 1.92969 4.10058 4.31397C4.10986 6.73536 5.91894 8.71143 8.16406 8.71143ZM8.16406 7.08789C6.88379 7.08789 5.79834 5.87256 5.79834 4.31397C5.78906 2.79248 6.87451 1.62354 8.16406 1.62354C9.46286 1.62354 10.5298 2.77393 10.5298 4.29541C10.5298 5.85401 9.45366 7.08789 8.16406 7.08789ZM2.375 17.3394H13.9439C15.5489 17.3394 16.3189 16.8291 16.3189 15.7344C16.3189 13.1831 13.1368 9.78757 8.16406 9.78757C3.1914 9.78757 0 13.1831 0 15.7344C0 16.8291 0.770022 17.3394 2.375 17.3394ZM2.0874 15.7159C1.86474 15.7159 1.78125 15.6416 1.78125 15.4746C1.78125 14.0552 4.07275 11.4112 8.16406 11.4112C12.2461 11.4112 14.5376 14.0552 14.5376 15.4746C14.5376 15.6416 14.4541 15.7159 14.2315 15.7159H2.0874Z",
    fill: "#0A0C0B",
    stroke: "var(--svgaccordioncolor)",
    strokeWidth: 2,
    mask: "url(#path-3-inside-1_5_2)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5_2",
    x: -41,
    y: -156,
    width: 250,
    height: 730,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1152,
    height: 700,
    fill: "white",
    transform: "translate(-26 -143)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidate);
export default __webpack_public_path__ + "static/media/Candidate.94cfe2578434b1297f6f081094e91950.svg";
export { ForwardRef as ReactComponent };